export default (testFramework: any) =>
  `<html>
  <head>
    <base href="/" />

    <link rel="preconnect" href="https://fonts.googleapis.com" />
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
    <link
    rel="stylesheet"
    href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200&display=block"
  />
    <link
      rel="stylesheet"
      href="https://fonts.googleapis.com/css2?family=Red+Hat+Display:wght@400;700&display=block"
    />
    <link
      href="https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;1,500&display=block"
      rel="stylesheet"
    />
    <link rel="stylesheet" href="https://unpkg.com/@digital-realty/theme@^2.0.0/dist/css/tw-reset-output.css" /><link rel="stylesheet" href="https://unpkg.com/@digital-realty/theme@^2.0.0/dist/css/baseTheme.css" />
    <script>
      window.process = { env: { NODE_ENV: 'production' } };
    </script>
        <script type="module" src="${testFramework}"></script>
    </head>
      <body>
      </body>
    </html>`;
